import { render, staticRenderFns } from "./ChangePasswordSuccessModal.vue?vue&type=template&id=86a63a56&scoped=true"
import script from "./ChangePasswordSuccessModal.vue?vue&type=script&lang=js"
export * from "./ChangePasswordSuccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a63a56",
  null
  
)

export default component.exports